import BaseAPI from './base'

class TeacherExamPeriodAPI extends BaseAPI {}

export default new TeacherExamPeriodAPI('v1/teacher-exam-period', 'TeacherExamPeriod')
